var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99937 1.74634C7.30855 1.74634 6.74854 2.30635 6.74854 2.99717V4.998V4.99805H13.2519V4.998V2.99717C13.2519 2.30635 12.6919 1.74634 12.001 1.74634H7.99937ZM5.24854 4.998V4.99805H2.99742C1.89239 4.99805 0.996582 5.89385 0.996582 6.99888V8.24399C1.48491 9.42166 2.64572 10.25 4 10.25H7.25V9.5C7.25 8.80964 7.80964 8.25 8.5 8.25H11.5C12.1904 8.25 12.75 8.80964 12.75 9.5V10.25H16C17.3549 10.25 18.5161 9.42091 19.0041 8.24239V6.99888C19.0041 5.89385 18.1083 4.99805 17.0032 4.99805H14.7519V4.998V2.99717C14.7519 1.47793 13.5203 0.246338 12.001 0.246338H7.99937C6.48013 0.246338 5.24854 1.47793 5.24854 2.99717V4.998ZM19.0041 10.6796C18.1855 11.3487 17.1396 11.75 16 11.75H12.725C12.6092 12.3206 12.1047 12.75 11.5 12.75H8.5C7.89526 12.75 7.39082 12.3206 7.275 11.75H4C2.86066 11.75 1.81502 11.3489 0.996582 10.6801V15.0022C0.996582 17.2123 2.78819 19.0039 4.99825 19.0039H15.0024C17.2125 19.0039 19.0041 17.2123 19.0041 15.0022V10.6796ZM8.75 11.25V11V9.75H11.25V11V11.25H8.75Z",
    fill: "#021317"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatorIcon);
export default __webpack_public_path__ + "static/media/operator_icon.4f1504a11e9be5d43b5b6f23f88601b0.svg";
export { ForwardRef as ReactComponent };